import React from 'react'
import { getOpportunityById } from '../services/oportunidadesService'
import { getMonitorById } from '../services/monitoringService'
import { fetchAssetsMeta } from '../utils/assets'
import type { OportunidadeModalItem } from '../context/OportunidadeModalContext'

export function useOportunidadeDetails(item: OportunidadeModalItem | null) {
  const [data, setData] = React.useState<any | null>(null)
  const [asset, setAsset] = React.useState<any | null>(null)
  const [loading, setLoading] = React.useState(false)
  const [error, setError] = React.useState<string | null>(null)

  React.useEffect(() => {
    let cancelled = false
    async function run() {
      if (!item?.id) { setData(null); setAsset(null); return }
      setLoading(true); setError(null)
      try {
        const row = item.kind === 'monitor' ? await getMonitorById(item.id) : await getOpportunityById(item.id)
        if (!cancelled) setData(row)
        const symbol = String(row?.symbol || item.symbol || '').trim()
        if (symbol) {
          const assets = await fetchAssetsMeta([symbol])
          if (!cancelled) setAsset(assets?.[0] || null)
        } else {
          if (!cancelled) setAsset(null)
        }
      } catch (e: any) {
        if (!cancelled) setError(e?.message || 'Falha ao carregar detalhes')
      } finally {
        if (!cancelled) setLoading(false)
      }
    }
    run()
    return () => { cancelled = true }
  }, [item?.id, item?.kind, item?.symbol])

  return { data, asset, loading, error }
}

